import en from './translations.en-US.json';

export const translations = { en };
